import $ from "jquery";
import AOS from "aos";
import {$Win} from "../utils/jQueryGlobals";
import debounce from "lodash.debounce";
import Component from "../models/Component";

export default class AOScont extends Component {
    constructor(element, context) {
        super(element, context);
        $Win.on('load', () => {
            setTimeout(() => {
                this.updateAOSdelay();
                AOS.init({
                    easing: 'ease-out-back',
                    duration: 500,
                    offset: 100,
                    once: true
                });
            }, 200);
        });
        $Win.on('resize', debounce(() => this.updateAOSdelay(), 100));
    }

    updateAOSdelay() {
        let o = 0,
            c = 0;
        this.element.find('[data-aos]').sort((a, b) => {
            let x = Math.round($(a).offset().top),
                y = Math.round($(b).offset().top);
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }).each((index, e) => {
            e = $(e);
            let co = Math.round(e.offset().top);
            if (o !== co) {
                o = co;
                c = 0;
            }
            e.attr('data-aos-delay', 200 * c);
            c++;
        });
    }
}
